import { css } from '@adornis/chemistry/directives/css.js';
import type { XTinyMCEPlugin } from '@adornis/writer/x-tinymce.js';
import { ChromiumDialog } from '@chancenwerk/design/components/cr-dialog.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('campus-tiny-plugin-videolyser')
export class CampusTinyPluginVideolyser extends ChromiumDialog<{ link: string; lessonName: string } | undefined> {
  private _link: string = '';

  static override get element_name() {
    return 'campus-tiny-plugin-videolyser';
  }

  override heading = 'Videolyser einbetten';

  override content() {
    return html`<cr-flex space="md" ${css({ maxWidth: '500px' })}>
      <cr-card raised space="md">
        <cr-text bold>Wie gehts?</cr-text>
        <cr-text>
          Um ein Videolyser-Video einzubetten, öffne dieses und klicke unter "Video-Einstellungen" auf
          "Einbettungscode". Kopiere nun "Deine Video URL" in das Textfeld.
        </cr-text>
        <cr-text>
          <cr-text bold>Achtung:</cr-text> Nach dem einbetten kann es ein paar Sekunden dauern, bis das Video im Editor
          angezeigt wird.
        </cr-text>
      </cr-card>
      <cr-input
        placeholder="Deine Video URL"
        value="${this._link}"
        @value-picked=${e => (this._link = e.detail.value)}
      ></cr-input>
      <cr-button
        @click=${async () => {
          await this.close({ link: this._link });
        }}
      >
        Einbetten
      </cr-button>
    </cr-flex>`;
  }
}

export const campusTinyPluginVideolyser: XTinyMCEPlugin = {
  name: 'campus-tiny-plugin-videolyser',
  setup: (editor, url) => {
    const openDialog = async () => {
      const linkObject = await CampusTinyPluginVideolyser.showPopup<{ link: string; lessonName: string } | undefined>();

      // https://www.videolyser.de/video/ID/Width/Height extract the id, width and height from the link
      const split = linkObject?.link.split('/');
      const id = split?.[split.length - 3];

      editor.insertContent(
        ` <div style="position:relative;padding-bottom:64.6875%;overflow:hidden;width:100%;height:auto" class="vdldiv">
            <iframe
              id="videolyser${id}"
              name="videolyser${id}"
              src="${linkObject?.link}"
              width="100%" height="100%"
              frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" scrolling="no"
              style="position:absolute;top:0;left:0;width:100%;height:100%;margin:0" referrerpolicy="origin-when-cross-origin" class="vdliframe">
            </iframe>
          </div>`,
        {
          format: 'raw',
        },
      );
    };
    /* Add a button that opens a window */
    editor.ui.registry.addButton('campus-tiny-plugin-videolyser', {
      text: 'Videolyser',
      onAction: async () => {
        /* Open window */
        await openDialog();
      },
    });
    /* Return the metadata for the help plugin */
    return {
      getMetadata: () => {
        return {
          name: 'Videolyser plugin',
          url: 'http://exampleplugin2docsurl.com',
        };
      },
    };
  },
};
